export default class ShopListView {
  constructor() {
    const hasCategory = window.ItemCategories || [];

    this.category = {
      itemCategory: hasCategory[0] || '',
      itemCategory2: hasCategory[1] || '',
      itemCategory3: hasCategory[2] || '',
      itemCategory4: hasCategory[3] || '',
      itemCategory5: hasCategory[4] || '',
      url: window.location.href,
    };
  }

  getItemListName() {
    let combineCategory = '';

    for (const key in this.category) {
      if (key !== 'url' && this.category[key]) {
        if (combineCategory === '') {
          combineCategory = this.category[key];
        } else {
          combineCategory = `${combineCategory}--${this.category[key]}`;
        }
      }
    }

    const searchParams = new URLSearchParams(decodeURI(window.location.search));
    const page = searchParams.get('Page');

    combineCategory = page
      ? `${combineCategory} 產品列表 Page ${page}`
      : `${combineCategory} 產品列表`;

    return combineCategory;
  }

  getListInfo() {
    const allListItem = window.dataLayer.find((obj) => obj.ecommerce && obj.ecommerce.impressions);

    let items = [];

    if (allListItem) {
      items = allListItem.ecommerce.impressions.map((item, index) => {
        return {
          item_id: item.id,
          item_name: item.name,
          index,
          item_list_name: item.list,
          item_brand: '',
          item_category: this.category.itemCategory,
          item_category2: this.category.itemCategory2,
          item_category3: this.category.itemCategory3,
          item_category4: this.category.itemCategory4,
          item_category5: this.category.itemCategory5,
          price: parseInt(item.price),
          quantity: 1,
          affiliation: item.variant,
        };
      });
    }

    return items;
  }

  getRecommendListInfo(listName) {
    const allListItem = window.dataLayer.find((obj) => obj.ecommerce && obj.ecommerce.impressions);

    const items = [];

    if (allListItem) {
      allListItem.ecommerce.impressions.forEach((item, index) => {
        const impression = {
          item_id: item.id,
          item_name: item.name,
          index,
          item_list_name: listName,
          item_brand: '',
          item_category: this.category.itemCategory,
          item_category2: this.category.itemCategory2,
          item_category3: this.category.itemCategory3,
          item_category4: this.category.itemCategory4,
          item_category5: this.category.itemCategory5,
          price: parseInt(item.price),
          quantity: 1,
          affiliation: item.variant,
        };
        items.push(impression);
      });
    }

    return items;
  }

  getSearchRecommendListInfo(listName, recommendData) {
    const recommendItems = recommendData.map((data, index) => {
      return {
        item_id: data.Colors[0].CustomMarketID.split('SZ')[0],
        item_name: data.Name,
        index,
        item_list_name: listName,
        item_brand: '',
        item_category: this.category.itemCategory,
        item_category2: this.category.itemCategory2,
        item_category3: this.category.itemCategory3,
        item_category4: this.category.itemCategory4,
        item_category5: this.category.itemCategory5,
        price: parseInt(data.SellPrice),
        quantity: 1,
        affiliation: data.Colors[0].ColorName,
      };
    });

    return recommendItems;
  }

  static getSearchListInfo(payload, listName) {
    const allListItem = window.dataLayer.find((obj) => obj.ecommerce && obj.ecommerce.impressions);

    let items = [];

    if (allListItem) {
      items = allListItem.ecommerce.impressions.map((item, index) => {
        return {
          item_id: item.id,
          item_name: item.name,
          index,
          item_list_name: listName,
          item_brand: '',
          item_category: payload.isHotSearch ? '關鍵字熱搜' : '關鍵字搜尋',
          item_category2: payload.keyword,
          price: parseInt(item.price),
          quantity: 1,
          affiliation: item.variant,
        };
      });
    }

    return items;
  }

  static getPromotionInfo() {
    const promotionFromStorage = JSON.parse(localStorage.getItem('promotion'));

    return promotionFromStorage || null;
  }

  static checkIsHotSearch(hotList) {
    const params = new URL(window.location.href).searchParams;
    const keyword = params.get('keyword') || params.get('Keyword') || '';

    if (hotList.length === 0) return { isHotSearch: false, keyword };

    const isHotSearch = hotList.includes(keyword);

    return { isHotSearch, keyword };
  }
}
